export default "__VITE_ASSET__936c7248__"